module.exports = __webpack_public_path__ + "static/media/search-sort.b6260c78.svg";